import React from 'react';
import {Text, TextMessage} from 'components/tt-forms/common';
import moment from 'moment';
import { ShowIf } from 'components/utils';
import {BlockBaoCaoKQTTXM} from 'modules/giai-quyet-don/subView';

class BlockGiaiQuyetDonInfo extends React.Component {
  componentDidMount() {
    if(window.debug) {
      console.log('modules/giai-quyet-don/subView/BlockGiaiQuyetDonInfo');
    }
  }
  render() {
    let DataDetail = this.props.thongTinGQD;
    let donInfo = this.props.donInfo || {};
    let showBaoCaoTTXM = false;
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (DataDetail.donViGiaoThamTraXacMinhInfo && userInfo.donViId == DataDetail.donViGiaoThamTraXacMinhInfo.coQuanQuanLyId) {
      showBaoCaoTTXM = true;
    }
    return (
      <div>
        <ShowIf condition={DataDetail.huongThuLyGiaiQuyet != 'TU_TTXM' && showBaoCaoTTXM}>
          <div className="mlr-5">
            <BlockBaoCaoKQTTXM donInfo={this.props.donInfo} thongTinGQD={this.props.thongTinGQD}/>
          </div>
          <div className="wrap-big-line pt5 pb15">
            <span className="big-border"></span>
          </div>
        </ShowIf>
        <ShowIf condition={donInfo.loaiDon == 'DON_TO_CAO' && DataDetail.giaHanGiaiQuyet}>
          <div className="mlr-5">
            <div className="col-100">
              <h3 className="title-12 mb10 mt0">Gia hạn xác minh nội dung tố cáo:</h3>
            </div>
            <Text className="col-25 mb15" label="Số quyết định gia hạn:" value={DataDetail.soQuyetDinhGiaHanGiaiQuyet ? DataDetail.soQuyetDinhGiaHanGiaiQuyet : ''}/>
            <Text className="col-25 mb15" label="Ngày ra quyết định:" value={DataDetail.ngayRaQuyetDinhGiaHanGiaiQuyet ? moment(DataDetail.ngayRaQuyetDinhGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
            <Text className="col-25 mb15" red={true} label="Gia hạn giải quyết đến ngày:" value={DataDetail.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(DataDetail.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
            <TextMessage className="col-100" label="Lý do gia hạn:" value={DataDetail.lyDoGiaHanGiaiQuyet ? DataDetail.lyDoGiaHanGiaiQuyet : ''}/>
          </div>
          <div className="wrap-big-line pt5 pb15">
            <span className="big-border"></span>
          </div>
        </ShowIf>
        <ShowIf condition={donInfo.saveTmp === false && DataDetail.doiThoai === true && (donInfo.loaiDon === 'DON_KHIEU_NAI' || donInfo.loaiDon === 'DON_TRANH_CHAP_DAT')}>
          <div className="col-100 mlr-5 pb10">
            <h2 className="title-12 mb15">Đối thoại</h2>
            <div className="row pl10 pr10">
              <Text className="col-25 mb10" label="Thời gian đối thoại:" value={DataDetail.thoiGianDoiThoai ? moment(DataDetail.thoiGianDoiThoai).format('DD/MM/YYYY') : ''}/>
              <Text className="col-75 mb10" label="Địa điểm:" value={DataDetail.diaDiemDoiThoai ? DataDetail.diaDiemDoiThoai : ''}/>
              <TextMessage className="col-100 mb0-18" label="Nội dung, kết quả đối thoại:" value={DataDetail.noiDungDoiThoai ? DataDetail.noiDungDoiThoai : ''}/>
            </div>
          </div>
          <div className="wrap-big-line pt5 pb15">
            <span className="big-border"></span>
          </div>
        </ShowIf>
        <ShowIf condition={donInfo.saveTmp === false && DataDetail.ngayHetHanGiaoLapDuThao}>
          <div className="col-100 mlr-5 pb10">
            <h2 className="title-12 mb15">Giao dự thảo quyết định giải quyết khiếu nại</h2>
            <div className="row pl10 pr10">
              <Text className="col-25 mb10" label="Thời gian trình dự thảo:" red={true} value={DataDetail.ngayHetHanGiaoLapDuThao ? moment(DataDetail.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : ''}/>
              <TextMessage className="col-100 mb0-18" label="Ý kiến xử lý:" value={this.props && DataDetail.noiDungGiaoLapDuThao ? DataDetail.noiDungGiaoLapDuThao : ''}/>
            </div>
          </div>
          <div className="wrap-big-line pt5 pb15">
            <span className="big-border"></span>
          </div>
        </ShowIf>
        <ShowIf condition={DataDetail.ngayKetThucGiaoLapDuThao}>
          <div className="col-100 pb10 mlr-5">
            <h2 className="title-12 mb15">Dự thảo quyết định giải quyết khiếu nại</h2>
            <div className="row pl10 pr10">
              <Text className="col-25 mb10" label="Ngày trình dự thảo:" value={DataDetail.ngayKetThucGiaoLapDuThao ? moment(DataDetail.ngayKetThucGiaoLapDuThao).format('DD/MM/YYYY') : ''}/>
              <TextMessage className="col-100 mb0-18" label="Tóm tắt nội dung kết quả đối thoại:" value={DataDetail.noiDungKetLuanDuThao ? DataDetail.noiDungKetLuanDuThao : ''}/>
            </div>
          </div>
          <div className="wrap-big-line pt5 pb15">
            <span className="big-border"></span>
          </div>
        </ShowIf>
      </div>
    );
  }
}

BlockGiaiQuyetDonInfo.defaultProps = {
  donInfo: {}
}

export default BlockGiaiQuyetDonInfo;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/BlockGiaiQuyetDonInfo.jsx